module.exports = __webpack_public_path__ + "static/curtain-highres-bd59182dfcfbf3c3b156682e84f1acf9.mp4";